// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".008b2f0dced97ae65bbef9ad33afe7ff17349f63.chunk.js";
};